var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { cloneElement, useCallback, useState, Children as ReactChildren, useEffect, } from 'react';
import { SystemIcon } from '@storeblocks/icon';
import { BreadcrumbsBase } from './styled';
const COLLAPSE_DEFAULT = 3;
/**
 * TODO: fix component to be not be an uncontrolled one
 */
function Breadcrumbs(_a) {
    var { children, collapseLimit = COLLAPSE_DEFAULT } = _a, props = __rest(_a, ["children", "collapseLimit"]);
    if (collapseLimit < 2) {
        throw new Error('collapseLimit cannot be less then 2. Please set collapseLimit to at least 2');
    }
    const childrenCount = ReactChildren.count(children);
    const shouldCollapse = childrenCount <= collapseLimit;
    const [open, set] = useState(shouldCollapse);
    useEffect(() => {
        set(shouldCollapse);
    }, [shouldCollapse]);
    const renderChildren = useCallback(() => {
        const childrenTransformed = ReactChildren.map(children, transform);
        if (open) {
            return childrenTransformed;
        }
        const first = childrenTransformed[0];
        const last = childrenTransformed.slice(-1);
        return (React.createElement(React.Fragment, null,
            first,
            React.createElement("button", { type: "button", onClick: () => set(true) },
                React.createElement("span", { "aria-label": "expand" }, "..."),
                React.createElement(SystemIcon, { name: "chevron-right", size: 16 })),
            last));
    }, [open, children]);
    return React.createElement(BreadcrumbsBase, Object.assign({}, props), renderChildren());
}
function transform(child) {
    return cloneElement(child, Object.assign(Object.assign({}, child.props), { children: (React.createElement(React.Fragment, null,
            React.createElement("span", null, child.props.children),
            React.createElement(SystemIcon, { name: "chevron-right", size: 16 }))) }));
}
export default Breadcrumbs;
